// extracted by mini-css-extract-plugin
module.exports = {"artworks":"LatestArtworks_artworks__KfL1r","btnWrap":"LatestArtworks_btnWrap__m1GXh","lastCard":"LatestArtworks_lastCard__huSZg"};